import { ProductType } from '@inter-ikea-storageone/range';
import PillTypeFilter from 'filters/TypeFilter/PillTypeFilter';
import { FilterType } from 'rangeConfig/@types';

export const smastadFrameTypeFilter = {
  component: PillTypeFilter,
  title: 'storageone.typeFilterLabel',
  id: 'smastad-frame-type',
  type: FilterType.FILTER,
  options: [
    {
      id: 'frames',
      name: 'storageone.smastadFilterLabelFrame',
      types: [ProductType.SMASTAD_FRAME, ProductType.SMASTAD_FRAME_NA_ASM]
    },
    {
      id: 'pullout-frames',
      name: 'storageone.smastadFilterLabelPullout',
      types: [
        ProductType.SMASTAD_PULL_OUT_FRAME_108_ASM,
        ProductType.SMASTAD_PULL_OUT_FRAME_196_ASM
      ]
    }
  ]
};
